import PropTypes from 'prop-types';

import styleSheet from './styles/scorePredictor.module.scss';

import { getImageUrl } from '../../helpers/images';

const styles = styleSheet.locals || {};

/**
 * Component for the scorePredictor hero
 *
 * @param {object} props props
 * @param {object} props.scorePredictor scorePredictor data
 * @param {boolean} props.isVisible - header hero visible, to decrease complexity of main components
 * @returns {Function} <Hero />
 */
function Hero({ scorePredictor, isVisible = true }) {
    const heroImg =
        scorePredictor.hero_image_url || scorePredictor.hero_external_image_url;

    if (!heroImg || !isVisible) {
        return null;
    }

    const renderHeroImage = () => {
        if (scorePredictor.hero_image_url) {
            return (
                <img
                    /* eslint-disable-next-line no-magic-numbers */
                    src={getImageUrl(scorePredictor.hero_image_url, 1784)}
                    alt={scorePredictor.hero_image_text || ''}
                    className={styles.scorePredictorHeroImage}
                    data-testid={'hero-image-manual'}
                />
            );
        }

        if (scorePredictor.hero_external_image_url) {
            return (
                <img
                    src={scorePredictor.hero_external_image_url}
                    alt={scorePredictor.hero_image_text || ''}
                    className={styles.scorePredictorHeroImage}
                    data-testid={'hero-image-automated'}
                />
            );
        }

        return null;
    };

    /* eslint-disable no-magic-numbers */
    return (
        <div
            data-cy="heroLabel"
            part="score-predictor-hero"
            className={styles.scorePredictorHero}
            data-testid="hero-image"
        >
            {renderHeroImage()}
        </div>
    );
}

Hero.propTypes = {
    scorePredictor: PropTypes.object.isRequired,
    isVisible: PropTypes.bool
};

export default Hero;
